import { Box } from '@common-fe/common-fe';
import styled from 'styled-components';

export const StyledContent = styled(Box)`
  display: block;
`;
